import { render, staticRenderFns } from "./editAlipay.vue?vue&type=template&id=3ca48301&scoped=true&"
import script from "./editAlipay.vue?vue&type=script&lang=js&"
export * from "./editAlipay.vue?vue&type=script&lang=js&"
import style0 from "./editAlipay.vue?vue&type=style&index=0&id=3ca48301&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca48301",
  null
  
)

export default component.exports